import * as actionTypes from "./actionTypes";
import { API } from "../../config/config";
import { headers } from "../../ultils/helpers";
import { reject } from "bluebird";
import { type } from "os";


export const getAllSlider = () => dispatch => {
  return new Promise((resolve, reject) => {
    fetch(API.GET_ALL_SLIDER_API, {
      headers: headers
    })
      .then(res => res.json())
      .then(data => {
        dispatch({
          type: actionTypes.GET_ALL_SLIDER,
          data: data
        })
        resolve(data)
      })
      .catch(err => reject(err))
  })

}